import { TUIConversationService } from '@tencentcloud/chat-uikit-engine';
export default {
  data() {
    return {};
  },
  methods: {
    collect(resumeId, jobId) {
      if (!jobId) {
        this.$Message.error({
          content: '请在筛选框选择岗位与对方沟通'
        });
        return true;
      }
      this.$axios
        .request({
          url: 'front/v1/company-talent',
          data: {
            resumeId: resumeId,
            jobId: jobId
          },
          method: 'post'
        })
        .then(res => {
          this.$Message.success({
            content: '加入人才库成功'
          });
          this.getList();
        });
    },

    invite(item) {
      this.$emit('invite', true);
    },
    sayHi(userId, jobId, open = true) {
      if (!this.timPrefix) {
        return;
      }
      if (this.goChatPost(userId, jobId)) {
        return;
      }
      if (open) this.$eventBus.$emit('openChat');
      TUIConversationService.switchConversation('C2C' + this.timPrefix + userId).catch(err => {
        this.$Message.error({
          content: '打开会话失败' + err.message
        });
      });
    },
    goChatPost(userId, jobId) {
      if (!jobId) {
        this.$Message.error({
          content: '请在筛选框选择岗位与对方沟通'
        });
        return true;
      }
      this.$axios.request({
        method: 'post',
        url: 'front/v1/chat',
        data: {
          to: userId,
          jobId: jobId
        }
      });
    }
  }
};
